import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Conditional } from '../../../primitives/Grid/Grid/components/Conditional.js';
import { Content } from '../../../primitives/Grid/Grid/components/Content.js';
export const Grid = /*#__PURE__*/_styled(({
  mq,
  ...restProps
}) => {
  if (mq) {
    return _jsx(Content, {
      ...restProps,
      mq: true
    });
  }
  return _jsx(Conditional, {
    ...restProps
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1mm25y30"
} : {
  target: "e1mm25y30",
  label: "Grid"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNHIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbmRpdGlvbmFsIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9HcmlkL0dyaWQvY29tcG9uZW50cy9Db25kaXRpb25hbC5qcyc7XG5pbXBvcnQgeyBDb250ZW50IH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9HcmlkL0dyaWQvY29tcG9uZW50cy9Db250ZW50LmpzJztcbmV4cG9ydCBjb25zdCBHcmlkID0gc3R5bGVkKCh7IG1xLCAuLi5yZXN0UHJvcHMgfSkgPT4ge1xuICAgIGlmIChtcSkge1xuICAgICAgICByZXR1cm4gX2pzeChDb250ZW50LCB7IC4uLnJlc3RQcm9wcywgbXE6IHRydWUgfSk7XG4gICAgfVxuICAgIHJldHVybiBfanN4KENvbmRpdGlvbmFsLCB7IC4uLnJlc3RQcm9wcyB9KTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9aW5kZXguanMubWFwIl19 */");